import { ThemeNames, ThemeType, } from '../types.js';
const name = ThemeNames.Saints;
const displayName = 'Southampton';
const type = ThemeType.Club;
const socials = {
    facebookUrl: 'https://www.facebook.com/profile.php?id=61586107954371',
    // etc.
};
const siteConfig = {
    gamblingCommissionUrl: 'www.gambleaware.org',
};
// TODO: Move to CMS
const assets = {
    logo: '/assets/images/saints/logo.svg',
    logoLight: '/assets/images/saints/logo-light.svg',
    logoMobile: '/assets/images/saints/logo-mobile.svg',
    logoBanner: '/assets/images/saints/logo.png',
    logoCard: '/assets/images/saints/logo.svg',
    loserImage: '/assets/images/saints/non-winner.webp',
    banner: '/assets/images/saints/banner.webp',
    postalIcon: '/assets/images/postal-icon-saints.svg',
    partners: [
        '/assets/images/partners/saints/1.png',
        '/assets/images/partners/saints/2.png',
        '/assets/images/partners/saints/4.png',
        '/assets/images/partners/saints/5.png',
    ],
    comingSoon: '/assets/images/banners/coming-soon-horizontal.png',
    comingSoonLarge: '/assets/images/banners/coming-soon.png',
};
const primitives = {
    theme: {
        extend: {
            colors: {
                white: '#F8FAFC',
                'pure-white': '#FFFFFF',
                primary: '#000000', // black
                'primary-light': '#FFD6DE', // lighter red
                'primary-lighter': '#FFD6DE', // lighter red
                secondary: '#C70128', // red
                'secondary-dark': '#C70128', // red
                'secondary-light': '#C70128', // red
                tertiary: '#C70128', // red
                'tertiary-light': '#C70128', // red
                'tertiary-dark': '#C70128', // red
                black: '#000000', // black
                'black-light': '#566989', // light black
                teal: '#C70128', // red
                'pastel-blue': '#C70128', // red
            },
        },
    },
};
const designTokens = {
    // General
    generalColorFocus: '#0085e5',
    // AbstractButton
    buttonBorderWidth: '1px',
    buttonBorderRadius: '1000px',
    buttonPrimaryDefaultBackground: '#e00027',
    buttonPrimaryDefaultForeground: '#ffffff',
    buttonPrimaryDefaultColorBorder: '#ffffff00',
    buttonPrimaryHoverBackground: '#ff0028',
    buttonPrimaryHoverForeground: '#ffffff',
    buttonPrimaryHoverColorBorder: '#ffffff00',
    buttonPrimaryPressedBackground: '#9e0020',
    buttonPrimaryPressedForeground: '#ffffff',
    buttonPrimaryPressedColorBorder: '#ffffff00',
    buttonSecondaryDefaultBackground: '#000000',
    buttonSecondaryDefaultForeground: '#ffffff',
    buttonSecondaryDefaultColorBorder: '#ffffff00',
    buttonSecondaryHoverBackground: '#232323',
    buttonSecondaryHoverForeground: '#ffffff',
    buttonSecondaryHoverColorBorder: '#ffffff00',
    buttonSecondaryPressedBackground: '#3b3b3b',
    buttonSecondaryPressedForeground: '#ffffff',
    buttonSecondaryPressedColorBorder: '#ffffff00',
    buttonTertiaryDefaultBackground: '#ffffff',
    buttonTertiaryDefaultForeground: '#082330',
    buttonTertiaryDefaultColorBorder: '#b6c6cf',
    buttonTertiaryHoverBackground: '#edf2f7',
    buttonTertiaryHoverForeground: '#082330',
    buttonTertiaryHoverColorBorder: '#b6c6cf',
    buttonTertiaryPressedBackground: '#e2eaed',
    buttonTertiaryPressedForeground: '#082330',
    buttonTertiaryPressedColorBorder: '#b6c6cf',
    // TextButton
    buttonTextFontFamily: 'Inter',
    buttonTextFontWeight: '700',
    buttonTextLineHeight: '1',
    buttonTextLgPaddingVertical: '12px',
    buttonTextLgPaddingHorizontal: '24px',
    buttonTextLgGap: '8px',
    buttonTextLgFontSize: '16px',
    buttonTextLgSizeIcon: '16px',
    buttonTextMdPaddingVertical: '8px',
    buttonTextMdPaddingHorizontal: '16px',
    buttonTextMdGap: '8px',
    buttonTextMdFontSize: '14px',
    buttonTextMdSizeIcon: '16px',
    buttonTextSmPaddingVertical: '6px',
    buttonTextSmPaddingHorizontal: '12px',
    buttonTextSmGap: '4px',
    buttonTextSmFontSize: '12px',
    buttonTextSmSizeIcon: '12px',
    // IconButton
    buttonIconXlPadding: '12px',
    buttonIconXlSizeIcon: '40px',
    buttonIconLgPadding: '8px',
    buttonIconLgSizeIcon: '24px',
    buttonIconMdPadding: '6px',
    buttonIconMdSizeIcon: '20px',
    buttonIconSmPadding: '4px',
    buttonIconSmSizeIcon: '16px',
    buttonIconTertiaryDefaultBackground: '#e2eaed',
    buttonIconTertiaryDefaultForeground: '#082330',
    buttonIconTertiaryDefaultColorBorder: '#e2eaed',
    buttonIconTertiaryHoverBackground: '#edf2f7',
    buttonIconTertiaryHoverForeground: '#082330',
    buttonIconTertiaryHoverColorBorder: '#edf2f7',
    buttonIconTertiaryPressedBackground: '#e2eaed',
    buttonIconTertiaryPressedForeground: '#082330',
    buttonIconTertiaryPressedColorBorder: '#e2eaed',
    // Checkbox
    checkboxSize: '24px',
    checkboxSizeTick: '16px',
    checkboxBorderRadius: '4px',
    checkboxBorderWidth: '1px',
    checkboxColorBorder: '#ff0028',
    checkboxDefaultBackground: '#ffffff',
    checkboxHoverBackground: '#edf2f7',
    checkboxPressedBackground: '#e2eaed',
    checkboxSelectedBackground: '#ff0028',
    checkboxSelectedForeground: '#ffffff',
    // Switch
    switchTrackPaddingHorizontal: '4px',
    switchTrackWidth: '52px',
    switchTrackHeight: '32px',
    switchTrackBorderWidth: '1px',
    switchTrackBorderRadius: '1000px',
    switchTrackBackground: '#e2eaed',
    switchTrackSelectedBackground: '#ff0028',
    switchHandleBorderRadius: '1000px',
    switchHandleSize: '24px',
    switchHandleDefaultBackground: '#082330',
    switchHandleHoverBackground: '#4c6475',
    switchHandlePressedBackground: '#01090c',
    switchHandleSelectedBackground: '#ffffff',
    switchHandleSelectedPressedBackground: '#e2eaed',
    // Tabs
    tabsItemForeground: '#082330',
    tabsItemSelector: '#ff0028',
    tabsItemSizeHighlight: '4px',
    tabsItemSizeIcon: '20px',
    tabsItemPaddingTop: '8px',
    tabsItemPaddingBottom: '12px',
    tabsItemPaddingHorizontal: '8px',
    tabsItemDefaultBackground: '#ffffff00',
    tabsItemHoverBackground: '#01090c0a',
    tabsItemPressedBackground: '#01090c14',
};
export default {
    assets,
    displayName,
    name,
    primitives,
    socials,
    type,
    designTokens,
    siteConfig,
};
